import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class DateFormatService {

  constructor() { }

  stringToFullDateTime(value: string): string {
    return moment(value).format('DD/MM/YYYY  HH:mm')
  }
}
